export const appRoutes = Object.freeze({
  /** Bootstrap entry point — host apps land here with token + dataset_id */
  bootstrap: "/",
  /** Launch entry point — backend-generated LaunchUrl lands here with ?token= */
  launch: "/launch",
  /** Flow routes — controlled by the flow resolver, never navigated to directly */
  flows: {
    einvoiceOnboarding: "/flows/einvoice-onboarding",
    einvoiceTables: "/flows/einvoice-received-invoices"
  },
  /** Standalone routes (available when not in embedded mode) */
  home: "/home",
  eInvoicingIdentifiers: "/e-invoicing-identifiers",
  invoices: "/invoices",
  invoiceDetails: "/invoices/:invoiceId",
  /** Error routes */
  expired: "/expired",
  error: "/error",
  sessionExpired: "/session-expired",
  notFound: "*"
});

/** Maps flow identifiers to their route paths */
export const FLOW_ROUTE_MAP = Object.freeze({
  einvoice_onboarding: appRoutes.flows.einvoiceOnboarding,
  received_einvoices: appRoutes.flows.einvoiceTables
} as const);
